import { useMutation } from "@tanstack/react-query";
import authService from "..";
import { ResetPasswordPayload } from "../type";

function useResetPassword() {
  return useMutation({
    mutationFn: (command: ResetPasswordPayload) => {
      return authService.resetPassword(command);
    },
  });
}

export default useResetPassword;
